import { render, staticRenderFns } from "./BlockSettings.vue?vue&type=template&id=568e22f4&scoped=true&"
import script from "./BlockSettings.vue?vue&type=script&lang=js&"
export * from "./BlockSettings.vue?vue&type=script&lang=js&"
import style0 from "./BlockSettings.vue?vue&type=style&index=0&id=568e22f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568e22f4",
  null
  
)

export default component.exports